module.exports = __webpack_public_path__ + "img/close.0bf335d5.svg";